<template>
    <v-card elevation="0">
        <v-card elevation="0" class="mx-1 pt-2 px-4 my-1">
            <v-row class="pb-3 pt-2">
                <h4 class="font-weight-light primary--text px-2">
                    Filtros
                </h4>
            </v-row>
            <!-- <v-divider class="mx-n1"></v-divider> -->
            <v-row no-gutters>
                <v-select
                    class="pa-4"
                    :items="opciones.cuenta.rol"
                    item-text="human"
                    item-value="encoded"
                    v-model="rol"
                    persistent-hint
                    :hint="
                        rol.length
                            ? 'Elimine los filtros para ver la selección completa'
                            : ''
                    "
                    multiple
                    prepend-inner-icon="mdi-gamepad-outline"
                    label="Elija un rol"
                    clearable
                >
                    <template #item="{ item }">
                        {{ item.human }}
                    </template>
                    <template #selection="{ item }">
                        <v-chip small dark color="red lighten-1">{{
                            item.human
                        }}</v-chip>
                    </template>
                </v-select>
            </v-row>
        </v-card>
        <v-card elevation="0" class="mx-1 pt-2 px-4 my-1">
            <!-- <v-row class="pb-3 pt-2">
                <h4 class="font-weight-light primary--text px-2">
                    Filtrar por Tipo
                </h4>
            </v-row>
            <v-divider class="mx-n1"></v-divider> -->
            <v-row no-gutters>
                <v-select
                    class="pa-4"
                    :items="opciones.cuenta.tipoComercial"
                    item-text="human"
                    item-value="encoded"
                    v-model="types"
                    persistent-hint
                    :hint="
                        types.length
                            ? 'Elimine los filtros para ver la selección completa'
                            : ''
                    "
                    multiple
                    prepend-inner-icon="mdi-filter"
                    label="Elija un tipo"
                    clearable
                >
                    <template #item="{ item }">
                        {{ item.human }}
                    </template>
                    <template #selection="{ item }">
                        <v-chip small dark color="orange lighten-1">{{
                            item.human
                        }}</v-chip>
                    </template>
                </v-select>
            </v-row>
        </v-card>
        <v-card elevation="0" class="mx-1 pt-2 px-4 my-1">
            <v-row class="pb-3 pt-2">
                <h4 class="font-weight-light primary--text px-2">
                    Comerciales Seleccionados
                </h4>
            </v-row>
            <!-- <v-divider class="mx-n1"></v-divider> -->
            <v-row no-gutters>
                <v-autocomplete
                    v-if="$store.getters['login/hasManagerPermission']"
                    class="pa-4"
                    :items="comercialesFilter"
                    v-model="correctiveFactor.commercials"
                    item-text="nombreCompleto"
                    return-object
                    multiple
                    prepend-inner-icon="mdi-account"
                    :hint="
                        !correctiveFactor.commercials.length
                            ? 'Selecciona los comerciales a los que se les establecerá este factor para este periodo'
                            : correctiveFactor.commercials.length +
                              ' seleccionados'
                    "
                    persistent-hint
                    label="Comercial"
                    clearable
                >
                    <template #item="{ item }">
                        <v-row>
                            <v-col cols="9">
                                {{ item.nombreCompleto }}
                            </v-col>
                            <v-col v-if="item.estado" cols="3">
                                <v-icon
                                    :color="estadoComercial[item.estado]"
                                    class="d-flex justify-center overline"
                                >
                                    mdi-circle
                                </v-icon>
                            </v-col>
                        </v-row>
                    </template>
                    <template #selection="{ item }">
                        <v-chip small color="lime">{{
                            item.nombreCompleto
                        }}</v-chip>
                    </template>
                </v-autocomplete>
            </v-row>
        </v-card>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { estadoComercial } from '@/util/libUtil.js';

export default {
    name: 'AddBadgeDialog',
    data: () => ({
        types: [],
        rol: [],
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        estadoComercial,
    }),
    methods: {},
    computed: {
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        comercialesFilter() {
            return this.rol.length == 0 && this.types.length == 0
                ? this.comerciales
                : this.comerciales.filter(
                      (comercial) =>
                          this.rol.some((rol) => rol == comercial.rol?.id) ||
                          this.types.some(
                              (type) => type == comercial.tipoComercial
                          )
                  );
        },
        correctiveFactor: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .correctiveFactor.form;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/correctiveFactor',
                    value
                );
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
            // opciones: (state) => state.opciones,
        }),
    },
};
</script>
